import { AType } from "@silversea-ssc/functional-support"
import { rebrandMaterialized } from "@ssc-booking/functional-support"
import { UUID } from "@ssc-booking/functional-support/src/uuid"
import { v4 as uuidv4 } from "uuid"

const _QuoteProcessId = /* @__PURE__ */ rebrandMaterialized(UUID, "QuoteProcessId")
export type QuoteProcessId = AType<typeof _QuoteProcessId>

export const QuoteProcessId = Object.assign(_QuoteProcessId, {
    new: (): QuoteProcessId => uuidv4() as QuoteProcessId,
    fromUUID: (uuid: UUID): QuoteProcessId => uuid as QuoteProcessId,
})
